import { render, staticRenderFns } from "./GalleryOverview.vue?vue&type=template&id=747234b3&scoped=true&"
import script from "./GalleryOverview.vue?vue&type=script&lang=ts&"
export * from "./GalleryOverview.vue?vue&type=script&lang=ts&"
import style0 from "./GalleryOverview.vue?vue&type=style&index=0&id=747234b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747234b3",
  null
  
)

export default component.exports